import React, { useState, useContext } from 'react';
import { FiVideo } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { InfluencerDataContext } from '../../../../contexts/InfluencerDataContext';
import { influencerApi } from '../../../../services/api/influencer';
import { ff } from '../../../../theme';
import { BannerCard } from './PromoBanner';

export default function UgcPromoBanner() {
  const navigate = useNavigate();
  const { influencerData } = useContext(InfluencerDataContext);
  const [isDismissed, setIsDismissed] = useState(false);

  const handleDismiss = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsDismissed(true);
    if (influencerData?.id) {
      influencerApi.updateProfile({ showCreatePortfolioBanner: false }, influencerData.id).catch(err =>
        console.error('Failed to dismiss UGC banner:', err)
      );
    }
  };

  if (isDismissed) return null;

  return (
    <BannerCard
      bg={ff.cream}
      icon={<FiVideo size={20} strokeWidth={2} aria-hidden />}
      title="Build your UGC portfolio"
      subtitle="Add your best content to get found for paid UGC deals."
      onClick={() => navigate('/profile', { state: { section: 'ugc' } })}
      onDismiss={handleDismiss}
    />
  );
}
